export const COMMON_TYPES = {
    FOCUS_SKU: 'FOCUS_SKU',
    RETAILER_EMPLOYEE_MAPPING: 'RETAILER_EMPLOYEE_MAPPING',
  };
  
  export const TEMPLATE_KEYS = {
    INSERT: {
      FOCUS_SKU: 'FOCUS_SKU',
      RETAILER_EMPLOYEE_MAPPING: 'RETAILER_EMPLOYEE_MAPPING',
    },
    DELETE: {
      FOCUS_SKU: 'FOCUS_SKU_DELETE',
      RETAILER_EMPLOYEE_MAPPING: 'RETAILER_EMPLOYEE_MAPPING',
    },
  };